<template>
  <aside class="main-sidebar">

    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <a href="/" class="logo">
        <!-- mini logo for sidebar mini 40x50 pixels -->
        <!--        <span class="logo-mini">
                  <img src="/static/img/suez-white.png" alt="Logo" class="img-responsive center-block"></span>-->
        <!-- logo for regular state and mobile devices -->
        <div class="logo-lg">
          <img src="/static/img/suez-white.png" alt="Logo" class="img-responsive">
        </div>
      </a>
      <!-- Sidebar user panel (optional) -->
      <div v-if="login.loggedIn" class="title-panel">
        <div class="info">
          <h2>Cantonniers, {{currentVille.name}}</h2>
          <hr/>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <sidebar-menu />
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
import {mapState} from 'vuex'
import SidebarMenu from './SidebarMenu'

export default {
  name: 'Sidebar',
  components: {
    SidebarMenu,
  },
  computed: {
    ...mapState([
      'currentVille',
      'login'
    ]),
  },
}
</script>
<style lang="scss">

@import '../scss/variables';

.main-sidebar {
  overflow: scroll !important;
  overflow-y: auto !important;
  overflow-x: auto !important;

  background: url('/static/img/rond-illu.svg') no-repeat -120px -20px;

  .title-panel  {
    color:white;
    text-align:center;
    padding:1em 0;
    h2 {
      margin-bottom:1rem;
    }
    hr {
      width:80%;
      border-color:$suez-steel;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Sidebar.vue?dcac3cb4